import amplifyConfig from '../config';
import API_PATH from './endpoints';
import axiosInstance from '../utils/axios';
import type { AxiosResponse } from 'axios';
import type { CreateUserParams, DeleteUserParams, GetUsersParams, UserType, UserWithOrganizationType, UpdateUserParams, AdminPowerUsers } from '../types/user';

const userAPI = {
  /**
   * ユーザ一覧の取得。オプションで特定の組織IDがあればその組織に所属するユーザ一覧を取得する
   * @params GetUsersParams
   * @return UserWithOrganizationType[]
   */
  getUsers: async (params: GetUsersParams) => {
    const endpoint: string = params.organizationId === undefined ? API_PATH.USER.USER : API_PATH.USER.USER_BY_ORGANIZATION + '/' + String(params.organizationId);
    return axiosInstance.get<undefined, AxiosResponse<UserWithOrganizationType[]>>(amplifyConfig.apiGateway.URL + endpoint);
  },

  /**
   * 商社アドミンおよびパワーユーザ一覧の取得
   * @return AdminPowerUsers[]
   */
  getAdminPowerUsers: async () => {
    return axiosInstance.get<undefined, AxiosResponse<AdminPowerUsers>>(amplifyConfig.apiGateway.URL + API_PATH.USER.ADMIN_POWERUSER);
  },

  /**
   * ユーザの作成
   * @param CreateUserParams
   * @return UserWithOrganizationType
   */
  createUser: async (params: CreateUserParams) => {
    return axiosInstance.post<CreateUserParams, AxiosResponse<UserWithOrganizationType>>(amplifyConfig.apiGateway.URL + API_PATH.USER.USER, params);
  },

  /**
   * ユーザの更新
   * @param UpdateUserParamsClient
   * @return UserWithOrganizationType
   */
  updateUser: async (params: UpdateUserParams) => {
    const { id } = params;
    return axiosInstance.put<UpdateUserParams, AxiosResponse<UserWithOrganizationType>>(amplifyConfig.apiGateway.URL + API_PATH.USER.USER + '/' + id, params);
  },

  /**
   * ユーザの削除
   * @param DeleteUserParams
   * @return UserType
   */
  deleteUser: async (params: DeleteUserParams) => {
    const { id } = params;
    return axiosInstance.delete<DeleteUserParams, AxiosResponse<UserType>>(amplifyConfig.apiGateway.URL + API_PATH.USER.USER + '/' + id);
  },
};

export default userAPI;
